<!--<div class="resultTab" [ngClass]="{'four-tabs': !showErlTab, 'five-tabs': showErlTab}">  -->
<div class="resultTab" [ngClass]="{'five-tabs': !showErlTab, 'six-tabs': showErlTab}">
  <h3 class="total">Total ({{totalNumberOfElements}})</h3>
  <p-tabView [(activeIndex)]="activeTabView"  (onChange)="handleTabChange()">
    <p-tabPanel [header]="('COMMON.ROW_STATUS.SUCCESS' | translate) + '('+numberOfProcessedElements+')'">
      <app-folds-list #app_folds_success [folds]="processedList" [columns]="columns" [selectFoldInput]="selectedFold"  [selectionType]="selectionType"
                      (selectFoldOutput)="handleChangeOfSelectFold($event)"></app-folds-list>
    </p-tabPanel>

    <p-tabPanel [header]="('COMMON.ROW_STATUS.DISCARD' | translate)+ '('+numberOfDiscardedElements+')'">
	    <app-folds-list  #app_folds_discard [folds]="discardedList" [columns]="columns" [selectFoldInput]="selectedFold" [selectionType]="selectionType"
                      (selectFoldOutput)="handleChangeOfSelectFold($event)" [showDiscardColumn]="true" ></app-folds-list>
    </p-tabPanel>

    <p-tabPanel [header]="('COMMON.ROW_STATUS.FAIL' | translate)+ '('+numberOfFailedElements+')'">
      <app-folds-list #app_folds_fail [folds]="failingList" [columns]="columns" [selectFoldInput]="selectedFold" [selectionType]="selectionType"
                      (selectFoldOutput)="handleChangeOfSelectFold($event)"></app-folds-list>
    </p-tabPanel>

    <p-tabPanel [header]="('COMMON.ROW_STATUS.WAIT' | translate)+ '('+numberOfWaitingElements+')'">
      <app-folds-list #app_folds_wait [folds]="waitingList" [columns]="columns" [selectFoldInput]="selectedFold" [selectionType]="selectionType"
                      (selectFoldOutput)="handleChangeOfSelectFold($event)"></app-folds-list>
    </p-tabPanel>
    <p-tabPanel [header]="('COMMON.ROW_STATUS.PLANNED' | translate) + '('+numberOfPlannedElements+')'">
      <app-folds-list [selectionType]="selectionType" [folds]="plannedList" [columns]="columns"
                     (selectFoldOutput)="handleChangeOfSelectFold($event)" [showDelayedsenddate]="true"></app-folds-list>
    </p-tabPanel>
    <p-tabPanel [header]="('COMMON.ROW_STATUS.ERL' | translate)+ '('+numberErlElements+')'" *ngIf="showErlTab">
	    <app-folds-list #app_folds_erl  [folds]="erlList" [columns]="erlColumns" [selectFoldInput]="selectedFold" [selectionType]="selectionType"
                      (selectFoldOutput)="handleChangeOfSelectFold($event)"></app-folds-list>
    </p-tabPanel>
    <p-tabPanel [header]="('COMMON.ROW_STATUS.ERL_DISCARD' | translate)+ '('+numberDiscardedErlElements+')'" *ngIf="showErlTab">
	    <app-folds-list #app_folds_discarded_erl  [folds]="discardedErlList" [columns]="erlColumns" [selectFoldInput]="selectedFold" [selectionType]="selectionType"
                      (selectFoldOutput)="handleChangeOfSelectFold($event)"></app-folds-list>
    </p-tabPanel>

  </p-tabView>
</div>
<div *ngIf="selectedFolds && selectedFolds.length === 1">
  <hr>
  <div class="grid">
    <div class="col-12 noPadding">
      <app-fold-detail [fold]="selectedFold"></app-fold-detail>
    </div>
    <div class="col-12 noPadding">
      <app-fold-action [fold]="selectedFold"></app-fold-action>
    </div>
  </div>
</div>
<div *ngIf="selectedFolds && selectedFolds.length >= 2">
  <hr>
  <div class="grid">
    <div class="col-12 noPadding">
      <app-multi-fold-action [folds]="selectedFolds"></app-multi-fold-action>
    </div>
  </div>
</div>
